export enum LivePollSessionState {
  WAITING_ROOM = 0,
  QUESTION_STARTED = 1,
  QUESTION_FINISHED = 2,
  COMPLETED = 3,
  TERMINATED_USER = 4,
  TERMINATED_SYSTEM = 5,
}
